var _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 209,
    viewBox: "0 0 194 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0769,
    d: "M171.701 96.6115C171.701 58.7652 141.021 28.0849 103.174 28.0849C65.3275 28.0849 34.6475 58.7652 34.6475 96.6115C34.6475 131.704 61.0274 160.631 95.0377 164.655L98.9219 171.383L103.613 179.508L108.305 171.383L112.257 164.538C145.809 160.094 171.701 131.378 171.701 96.6115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1538,
    d: "M171.36 96.2713C171.36 58.4251 140.68 27.7445 102.833 27.7445C64.987 27.7445 34.3066 58.4251 34.3066 96.2713C34.3066 131.364 60.6865 160.291 94.6969 164.315L98.5811 171.043L103.273 179.168L107.964 171.043L111.916 164.198C145.468 159.754 171.36 131.038 171.36 96.2713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2308,
    d: "M171.02 95.9309C171.02 58.0847 140.34 27.4044 102.493 27.4044C64.6468 27.4044 33.9668 58.0847 33.9668 95.9309C33.9668 131.024 60.3467 159.951 94.357 163.975L98.2412 170.702L102.933 178.828L107.624 170.702L111.576 163.857C145.128 159.414 171.02 130.698 171.02 95.9309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3077,
    d: "M170.679 95.5904C170.679 57.7441 139.999 27.0635 102.153 27.0635C64.3063 27.0635 33.626 57.7441 33.626 95.5904C33.626 130.683 60.0059 159.61 94.0162 163.634L97.9004 170.362L102.592 178.487L107.284 170.362L111.235 163.517C144.787 159.073 170.679 130.357 170.679 95.5904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3846,
    d: "M170.34 95.2499C170.34 57.4037 139.659 26.7234 101.813 26.7234C63.9664 26.7234 33.2861 57.4037 33.2861 95.2499C33.2861 130.343 59.666 159.27 93.6764 163.294L97.5606 170.021L102.252 178.147L106.944 170.021L110.896 163.176C144.448 158.733 170.34 130.017 170.34 95.2499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5385,
    d: "M169.659 94.569C169.659 56.7227 138.978 26.0424 101.132 26.0424C63.2858 26.0424 32.6055 56.7227 32.6055 94.569C32.6055 129.662 58.9854 158.589 92.9957 162.613L96.8799 169.34L101.571 177.466L106.263 169.34L110.215 162.495C143.767 158.052 169.659 129.336 169.659 94.569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6154,
    d: "M169.318 94.2287C169.318 56.3824 138.637 25.7018 100.791 25.7018C62.945 25.7018 32.2646 56.3824 32.2646 94.2287C32.2646 129.321 58.6445 158.248 92.6549 162.272L96.5391 169L101.231 177.126L105.922 169L109.874 162.155C143.426 157.711 169.318 128.995 169.318 94.2287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6923,
    d: "M168.977 93.8881C168.977 56.0418 138.296 25.3615 100.45 25.3615C62.6039 25.3615 31.9238 56.0421 31.9238 93.8881C31.9238 128.981 58.3037 157.908 92.3141 161.932L96.1983 168.659L100.89 176.785L105.581 168.659L109.533 161.815C143.085 157.371 168.977 128.655 168.977 93.8881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7692,
    d: "M168.637 93.5477C168.637 55.7015 137.957 25.0209 100.111 25.0209C62.2643 25.0209 31.584 55.7015 31.584 93.5477C31.584 128.64 57.9639 157.567 91.9742 161.591L95.8584 168.319L100.55 176.445L105.242 168.319L109.193 161.474C142.746 157.031 168.637 128.314 168.637 93.5477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8462,
    d: "M168.297 93.2073C168.297 55.361 137.616 24.6807 99.7697 24.6807C61.9235 24.6807 31.2432 55.361 31.2432 93.2073C31.2432 128.3 57.6231 157.227 91.6334 161.251L95.5176 167.979L100.209 176.104L104.901 167.979L108.853 161.134C142.405 156.69 168.297 127.974 168.297 93.2073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9231,
    d: "M167.957 92.867C167.957 55.0207 137.276 24.3401 99.4299 24.3401C61.5836 24.3401 30.9033 55.0207 30.9033 92.867C30.9033 127.96 57.2832 156.887 91.2936 160.911L95.1778 167.638L99.8693 175.764L104.561 167.638L108.513 160.793C142.065 156.35 167.957 127.634 167.957 92.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.616 92.5266C167.616 54.6803 136.935 24 99.0891 24C61.2428 24 30.5625 54.6803 30.5625 92.5266C30.5625 127.619 56.9424 156.546 90.9527 160.57L94.837 167.298L99.5285 175.424L104.22 167.298L108.172 160.453C141.724 156.009 167.616 127.293 167.616 92.5266Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0769,
    d: "M26.4775 96.6115C26.4775 58.7652 57.1579 28.0849 95.0041 28.0849C132.85 28.0849 163.531 58.7655 163.531 96.6115C163.531 131.704 137.151 160.631 103.141 164.655L99.2565 171.383L94.5649 179.508L89.8734 171.383L85.9214 164.538C52.3694 160.094 26.4775 131.378 26.4775 96.6115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1538,
    d: "M26.8184 96.2713C26.8184 58.4251 57.4987 27.7445 95.3452 27.7445C133.192 27.7445 163.871 58.4251 163.871 96.2713C163.871 131.364 137.492 160.291 103.481 164.315L99.5973 171.043L94.9058 179.168L90.2142 171.043L86.2623 164.198C52.71 159.754 26.8184 131.038 26.8184 96.2713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2308,
    d: "M27.1582 95.9309C27.1582 58.0847 57.8385 27.4044 95.6848 27.4044C133.531 27.4044 164.212 58.0847 164.212 95.9309C164.212 131.024 137.832 159.951 103.821 163.975L99.9371 170.702L95.2456 178.828L90.5541 170.702L86.6021 163.857C53.0498 159.414 27.1582 130.698 27.1582 95.9309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3077,
    d: "M27.499 95.5904C27.499 57.7441 58.1793 27.0635 96.0256 27.0635C133.872 27.0635 164.552 57.7441 164.552 95.5904C164.552 130.683 138.173 159.61 104.162 163.634L100.278 170.362L95.5864 178.487L90.8949 170.362L86.9429 163.517C53.3906 159.073 27.499 130.357 27.499 95.5904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3846,
    d: "M27.8389 95.2499C27.8389 57.4037 58.5192 26.7234 96.3654 26.7234C134.212 26.7234 164.892 57.404 164.892 95.2499C164.892 130.343 138.512 159.27 104.502 163.294L100.618 170.021L95.9263 178.147L91.2347 170.021L87.2828 163.176C53.7307 158.733 27.8389 130.017 27.8389 95.2499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4615,
    d: "M28.1797 94.9094C28.1797 57.0631 58.86 26.3826 96.7063 26.3826C134.552 26.3826 165.233 57.0631 165.233 94.9094C165.233 130.002 138.853 158.929 104.843 162.953L100.959 169.681L96.2671 177.806L91.5756 169.681L87.6236 162.836C54.0716 158.392 28.1797 129.676 28.1797 94.9094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_690_1569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2568 97.392C25.2568 57.8515 57.2507 25.7977 96.7174 25.7977C136.184 25.7977 168.178 57.8518 168.178 97.392C168.178 134.056 140.669 164.278 105.202 168.482L101.152 175.51L96.2594 184L91.367 175.51L87.2458 168.359C52.257 163.717 25.2568 133.715 25.2568 97.392Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6154,
    d: "M28.8604 94.2287C28.8604 56.3824 59.5407 25.7018 97.3869 25.7018C135.233 25.7018 165.914 56.3824 165.914 94.2287C165.914 129.321 139.534 158.248 105.523 162.272L101.639 169L96.9477 177.126L92.2562 169L88.3042 162.155C54.7519 157.711 28.8604 128.995 28.8604 94.2287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6923,
    d: "M29.2012 93.8881C29.2012 56.0418 59.8815 25.3615 97.7277 25.3615C135.574 25.3615 166.255 56.0421 166.255 93.8881C166.255 128.981 139.875 157.908 105.864 161.932L101.98 168.659L97.2886 176.785L92.597 168.659L88.6451 161.815C55.0928 157.371 29.2012 128.655 29.2012 93.8881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7692,
    d: "M29.541 93.5477C29.541 55.7015 60.2213 25.0209 98.0676 25.0209C135.914 25.0209 166.594 55.7015 166.594 93.5477C166.594 128.64 140.214 157.567 106.204 161.591L102.32 168.319L97.6284 176.445L92.9369 168.319L88.9849 161.474C55.4329 157.031 29.541 128.314 29.541 93.5477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8462,
    d: "M29.8818 93.2073C29.8818 55.361 60.5621 24.6807 98.4084 24.6807C136.255 24.6807 166.935 55.361 166.935 93.2073C166.935 128.3 140.555 157.227 106.545 161.251L102.661 167.979L97.9692 176.104L93.2777 167.979L89.3257 161.134C55.7737 156.69 29.8818 127.974 29.8818 93.2073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9231,
    d: "M30.2227 92.867C30.2227 55.0207 60.903 24.3401 98.7495 24.3401C136.596 24.3401 167.276 55.0207 167.276 92.867C167.276 127.96 140.896 156.887 106.886 160.911L103.002 167.638L98.3101 175.764L93.6185 167.638L89.6666 160.793C56.1143 156.35 30.2227 127.634 30.2227 92.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5625 92.5266C30.5625 54.6803 61.2428 24 99.0891 24C136.935 24 167.616 54.6806 167.616 92.5266C167.616 127.619 141.236 156.546 107.226 160.57L103.341 167.298L98.6499 175.424L93.9583 167.298L90.0064 160.453C56.4541 156.009 30.5625 127.293 30.5625 92.5266Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.616 92.5266C167.616 54.6803 136.935 24 99.0891 24C61.2428 24 30.5625 54.6803 30.5625 92.5266C30.5625 127.619 56.9424 156.546 90.9527 160.57L94.837 167.298L99.5285 175.424L104.22 167.298L108.172 160.453C141.724 156.009 167.616 127.293 167.616 92.5266Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5595 97.5032L91.951 73.4247C91.6495 68.7337 91.4986 65.3656 91.4986 63.3207C91.4986 60.5399 92.2274 58.3692 93.6852 56.8109C95.1431 55.2527 97.0612 54.4734 99.4411 54.4734C102.323 54.4734 104.25 55.4708 105.222 57.4644C106.193 59.4591 106.68 62.3325 106.68 66.0855C106.68 68.2972 106.562 70.5433 106.328 72.8214L104.166 97.6039C103.931 100.554 103.428 102.816 102.658 104.39C101.887 105.965 100.613 106.753 98.8378 106.753C97.0282 106.753 95.7715 105.991 95.0678 104.465C94.3636 102.941 93.861 100.62 93.5595 97.5032ZM99.139 130.58C97.0941 130.58 95.3096 129.917 93.7854 128.594C92.2603 127.271 91.498 125.42 91.498 123.04C91.498 120.963 92.2268 119.194 93.6847 117.736C95.1426 116.279 96.927 115.55 99.0384 115.55C101.15 115.55 102.95 116.279 104.442 117.736C105.933 119.194 106.679 120.963 106.679 123.04C106.679 125.386 105.925 127.229 104.417 128.569C102.909 129.909 101.15 130.58 99.139 130.58Z",
    fill: "url(#paint0_linear_690_1569)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_690_1569",
    x: 0.256836,
    y: 0.797729,
    width: 192.921,
    height: 208.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_690_1569"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_690_1569",
    x1: 94.978,
    y1: 37.8105,
    x2: 104.963,
    y2: 174.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.83db55fc2151248cdb14143d99c5e131.svg";
export { ForwardRef as ReactComponent };